import React, { useState, useEffect, useCallback } from 'react';
import api from 'services/api';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TextArea from 'v3/components/TextArea';

import { useSnackbar } from 'v3/components/Snackbar';
import { useParams } from 'react-router-dom';

import {
  Select,
  Text,
  Input,
  Radio,
} from 'v3/components'

import { useClient } from '../context';


export default function ClientTracking() {
  const { setClient, data, errors, sendIntervalOptions } = useClient();
  const [loadingCostCenters, setLoadingCostCenters] = useState(false);

  const params = useParams();
  const snackbar = useSnackbar();
  useEffect(() => {

    if (!params?.id) {
      setClient(old => ({
        ...old,
        client: {
          ...old.client,
          sending_tracking: false,
          emails_tracking: null,
          enable_logic_panel: true,
          total_send_email: null,
          time_interval: [],
          cost_centers: [],
        },
      }));
    }
  }, [params?.id]);

  async function fetchCostCenters(search) {
    try {
      const response = await api.get(`v3/cost-center`, {
        params: {
          search: search,
          ignoreCompanies: true
        },
      });

      return response.data;
    } catch (ex) {
      return [];
    }
  }

  const selectAllCostCenters = useCallback(async () => {
    try {
      setLoadingCostCenters(true);
      const allCostCenter = await fetchCostCenters('');

      if (allCostCenter.length === 0) {
        snackbar.show(<Text>Nenhum Centro de custo encontrado</Text>, {
          type: 'error',
        });
      }
      setClient(old => ({
        ...old,
        client: {
          ...old.client,
          cost_centers: allCostCenter,
        },
      }));
    } catch (error) {
      setClient(old => ({
        ...old, client: {
          ...old.client, cost_centers: []
        }
      }))
    } finally {
      setLoadingCostCenters(false);
    }
  }, [data?.client?.cost_centers]);


  useEffect(() => {
    if (data?.client?.cost_centers) {
      const costCentersIdsSelected = data?.client?.cost_centers.reduce(
        (acc, curr) => {
          acc.push(curr.id);
          return acc;
        },
        []
      );
      if (costCentersIdsSelected.includes('default')) {
        selectAllCostCenters();
      }
    }
  }, [data?.client?.cost_centers]);


  return (
    <Row className="form">
      <Col xs={12} md={12}>
        <Radio.Group
          label="Recebe Tracking"
          onChange={({ target }) => {

            if (target.value === true) {
              setClient(old => ({
                ...old,
                client: {
                  ...old.client,
                  sending_tracking: target.value
                },
              }));
            } else {
              setClient(old => ({
                ...old,
                client: {
                  ...old.client,
                  sending_tracking: target.value,
                  emails_tracking: null,
                  cost_centers: [],
                  total_send_email: null,
                  time_interval: [],
                },
              }));
            }
          }}
          value={data?.client?.sending_tracking}
          horizontal
        >
          <Radio value={true}>
            <Text color="dark" type="label">
              Sim
            </Text>
          </Radio>
          <Radio value={false}>
            <Text color="dark" type="label">
              Não
            </Text>
          </Radio>
        </Radio.Group>
      </Col>
      <Col xs={12} md={12}>
        <Radio.Group
          label="Mostrar no Painel Logístico: última localização, distância efetuada, distância restante, previsão de chegada?"
          onChange={({ target }) => {
            setClient(old => ({
              ...old,
              client: {
                ...old.client,
                enable_logic_panel: target.value
              },
            }));
          }}
          value={data?.client?.enable_logic_panel}
          horizontal
        >
          <Radio value={true}>
            <Text color="dark" type="label">
              Sim
            </Text>
          </Radio>
          <Radio value={false}>
            <Text color="dark" type="label">
              Não
            </Text>
          </Radio>
        </Radio.Group>
      </Col>
      {
        (
          data?.client?.sending_tracking === true && (
            <>
              <Col>
                <TextArea
                  value={data?.client?.emails_tracking}
                  label="Emails dos usuários *"
                  onChange={event => {
                    setClient(old => ({
                      ...old,
                      client: {
                        ...old.client,
                        emails_tracking: event.target.value
                      },
                    }));
                  }}
                  error={errors?.emails_tracking || errors?.['tracking.emails_tracking']}
                />
              </Col>
              <Col xs={12} md={12}>
                <Select.Async
                  label="Centro de custo *"
                  onSearch={search =>
                    fetchCostCenters(search)
                  }
                  options={[{ name: 'Selecionar todos os centros de custo', id: 'default' }]}
                  multiple
                  horizontal
                  value={data?.client?.cost_centers}
                  onChange={values => {
                    setClient(old => ({
                      ...old,
                      client: {
                        ...old.client,
                        cost_centers: values
                      },
                    }));
                  }}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  error={errors?.cost_centers || errors?.['tracking.cost_centers']}
                  loading={loadingCostCenters}
                />
              </Col>

              <Col xs={12} md={12}>
                <Select
                  label="Total de envios diários *"
                  options={sendIntervalOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.client?.total_send_email}
                  onChange={value => {
                    if (value?.id === 0) {
                      setClient(old => ({
                        ...old,
                        client: {
                          ...old.client,
                          total_send_email: value,
                          time_interval: [],
                        },
                      }));
                    } else {
                      const count = value?.id || 0;
                      const initialTimes = Array(count).fill("");
                      setClient(old => ({
                        ...old,
                        client: {
                          ...old.client,
                          total_send_email: value,
                          time_interval: initialTimes,
                        },
                      }));
                    }
                  }}
                  error={errors?.total_send_email || errors?.['tracking.total_send_email']}
                />
              </Col>
              {data?.client?.total_send_email?.id > 0 && (
                <>
                  <Col md={12} xs={12}>
                    <Text color="dark" type="label">Selecione os horários de envio *</Text>
                  </Col>

                  {data?.client?.time_interval?.map((time, index) => (
                    <Col key={index} md={3} >
                      <Input
                        type="time-interval"
                        timeInterval={30}
                        value={time}
                        onChange={e => {
                          const newTimes = [...data.client.time_interval];
                          newTimes[index] = e.target.value;
                          setClient(old => ({
                            ...old,
                            client: {
                              ...old.client,
                              time_interval: newTimes,
                            },
                          }));
                        }}
                        error={errors[`time_interval[${index}]`] || errors?.[`tracking.time_interval[${index}]`]}
                      />
                    </Col>
                  ))}
                </>
              )}
            </>
          )
        )
      }
    </Row>
  );
}